import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                acl: {
                    add: 'COSI_00335',
                    showDirectEditModal: 'COSI_XXXXX',
                },
                url: {
                    getMapFeatures: `${codeAPI}/front/map/features`,
                },
            },
            headernav: {
                tools: [
                    {component: 'dashboard', title: 'dashboard.title'},
                    {component: 'accountable', title: 'Minhas Ocorrências'},
                    {component: 'activity', title: 'Atividade Recente'},
                ]
            },
        },
        tools: {
            attribution: {
                active: false,
            },
            scaleline: {
                active: false,
            },
            scalebox: {
                active: false,
            },
            mouseposition: {
                active: false,
            },
            annotations: {
                active: false,
                acl: {
                    view: 'COSI_00641',
                },
            },
            measure: {
                active: false,
                acl: {
                    view: 'COSI_00642',
                },
            },
            backoffice: {
                active: true,
                title: 'Backoffice',
                label: 'Backoffice',
                panel: {
                    show: false,
                },
                acl: {
                    view: 'COSI_00575', // Nâo deveria ser o COSI_00006??
                },
                url: {
                    view: `:moduleCodegestao.home`,
                }
            },
            catalog: {
                active: false,
                acl: {
                    view: 'COSI_00638',
                },
            },
            identify: {
                active: false,
                acl: {
                    view: 'COSI_00639',
                },
            },
            layers: {
                active: true,
                title: 'Camadas',
                label: 'Camadas',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'COSI_00331',
                },
                url: {
                    getLayers: `${codeAPI}/front/map/layers`,
                },
                selected: null,
            },
            dashboard: {
                active: true,
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'COSI_00573',
                },
            },
            filtertype: {
                active: true,
                panel: {
                    show: false,
                    collapsed: true,
                    height: 0,
                },
                acl: {
                    view: 'COSI_00610',
                },
                url: {

                },
            },
            filterstatus: {
                active: true,
                panel: {
                    show: false,
                },
                acl: {
                    view: 'COSI_00609',
                },
                url: {

                },
            },
            activity: {
                active: true,
                title: "activity.title",
                panel: {
                    show: false,
                    loaded: false,
                    reload: false,
                    titleTemplate: "activity.tooltip",
                    txtNoRecords: "activity.no_records",
                    summary: [],
                    toggles: [
                        {'id': 1, 'name': 'activity.toggles.submitted.title', 'key': 'started'},
                        {'id': 2, 'name': 'activity.toggles.completed.title', 'key': 'finished'},
                    ],
                    reloadBtn: true,
                },
                acl: {
                    view: 'COSI_00572',
                },
                url: {
                    getData: `${codeAPI}/occurrences/data/activity`,
                },
            },
            accountable: {
                active: false,
                title: "accountable.title",
                panel: {
                    show: false,
                    loaded: false,
                    reload: false,
                    data: [],
                    toggles: [
                        {id: 1, key: 'my', name: "accountable.toggles.mine.title", expanded: false},
                        {id: 2, key: 'assigned_me', name: "accountable.toggles.assigned_me.title", expanded: false},
                        {id: 3, key: 'my_unity', name: "accountable.toggles.my_unity.title", expanded: false},
                    ],
                    reloadBtn: true,
                },
                acl: {
                    view: 'COSI_00630',
                },
                url: {
                    getData: `${codeAPI}/occurrences/data/accountable`,
                },
            },
            search: {
                active: true,
                title: "Lista de ocorrências",
                label: "Filtros",
                panel: {
                    show: false,
                    loaded: false,
                    reload: false,
                    allowExportData: true,
                    formatExportData: 'xls',
                },
                acl: {
                    view: 'COSI_00613',
                    viewDetails: 'COSI_00583',
                    export: 'COSI_00780',
                },
                url: {
                    searchAll: `${codeAPI}/occurrences/search`,
                    getLists: `${codeAPI}/occurrences/lists`,
                    getSubTypes: `${codeAPI}/occurrences/subtypes/:type`,
                    searchUser: `${codeAPI}/occurrences/search/user?q=:query`,
                    export: `${codeAPI}/occurrences/search/export`,
                    job: `${codeAPI}/occurrences/search/export/job/:id`,
                },
            },
            report: {
                active: true,
                title: "Relatórios",
                panel: {
                    show: false,
                    loaded: false,
                    reports: {
                        globalstatus: {
                            title: 'Informações Globais',
                            allowExportData: true,
                            formatExportData: 'xls',
                            url: {
                                data: `${codeAPI}/reports/occurrences/totalizer-status`,
                                export: `${codeAPI}/reports/occurrences/totalizer-status/export`,
                                job: `${codeAPI}/reports/occurrences/export/job/:id`,
                            }
                        },
                        monthlySummary: {
                            title: 'Resumo Mensal',
                            allowExportData: true,
                            formatExportData: 'xls',
                            url: {
                                data: `${codeAPI}/reports/occurrences/montly-resume`,
                                export: `${codeAPI}/reports/occurrences/montly-resume/export`,
                                job: `${codeAPI}/reports/occurrences/export/job/:id`,
                            }
                        },
                        performerSummary: {
                            title: 'Ocorrências por Executante',
                            allowExportData: true,
                            formatExportData: 'xls',
                            url: {
                                data: `${codeAPI}/reports/occurrences/occurrences-performer`,
                                export: `${codeAPI}/reports/occurrences/occurrences-performer/export`,
                                job: `${codeAPI}/reports/occurrences/export/job/:id`,
                            }
                        },
                        occurrencesSummary: {
                            title: 'Listagem de Ocorrências',
                            allowExportData: true,
                            formatExportData: 'xls',
                            url: {
                                data: `${codeAPI}/reports/occurrences/occurrences-summary`,
                                export: `${codeAPI}/reports/occurrences/occurrences-summary/export`,
                                job: `${codeAPI}/reports/occurrences/export/job/:id`,
                            }
                        },
                        statusChart: {
                            title: 'Gráfico dos Estados',
                            allowExportData: true,
                            formatExportData: 'xls',
                            url: {
                                data: `${codeAPI}/reports/occurrences/chart-status`,
                                export: `${codeAPI}/reports/occurrences/chart-status/export`,
                                job: `${codeAPI}/reports/occurrences/export/job/:id`,
                            }
                        },
                        subtypeChart: {
                            title: 'Gráfico das Espécies',
                            allowExportData: true,
                            formatExportData: 'xls',
                            url: {
                                data: `${codeAPI}/reports/occurrences/chart-kinds`,
                                export: `${codeAPI}/reports/occurrences/chart-kinds/export`,
                                job: `${codeAPI}/reports/occurrences/export/job/:id`,
                            }
                        },
                    },
                },
                acl: {
                    view: 'COSI_00332',
                    export: 'COSI_00332',
                },
                url: {
                    getFamilies: `${codeAPI}/occurrences/families`,
                    getStatuses: `${codeAPI}/occurrences/statuses`,
                },
            },
            navsearch: {
                active: true,
                panel: {
                    show: true,
                    showDefault: true,
                    categories: [{
                        'id': 'addr',
                        'name': 'navsearch.address.title',
                        'url': '../gateway/address/search',
                        'listGroup': 'adminName1',
                        'labelTemplate': 'navsearch.address.labelTemplate',
                        'subLabelTemplate': null,
                        'placeholder': 'navsearch.address.placeholder'
                    },
                    {
                        'id': 'cosi-oco',
                        'name': 'Ocorrência',
                        'url': `${codeAPI}/occurrences/search/code/:q`,
                        'labelTemplate': '${code}',
                        'placeholder': 'Ocorrência...'
                    }],
                    search: {
                        category: null,
                        item: null,
                    },
                },
            },
            viewfeature: {
                active: false,
                title: 'Detalhes da Ocorrência',
                panel: {
                    show: false,
                    loaded: false,
                    enableEdocLink: false,
                    closeAfterCloseEdit: true,
                },
                acl: {
                    view: 'COSI_00583',
                    edit: 'COSI_00570',
                    delete: 'COSI_00340',
                    notify: 'COSI_00357',

                    viewVisibility: 'COSI_00612',
                    viewInternalData: 'COSI_00451',
                    viewOriginalDescription: 'COSI_00607',
                    viewDescription: 'COSI_00608',
                    viewChannel: 'COSI_00600',
                    viewHistory: 'COSI_00341',
                    viewType: 'COSI_00603',
                    //viewSubType: 'COSI_00604',
                    viewUserInfo: 'COSI_00352',
                    viewFamily: 'COSI_00658',
                    viewKind: 'COSI_00659',
                    viewEntity: 'COSI_00655',
                    viewCategory: 'COSI_00656',
                    viewPersonData: 'COSI_00657',
                    viewTimeLine: 'COSI_00361',
                    viewTimeLineDetails: 'COSI_00363',
                    viewTimeLineAddButton: 'COSI_00362',
                    viewEdocLink: 'COSI_00622',
                },
                url: {
                    show: `${codeAPI}/occurrences/show/:code`,
                    showAnonymous: `${codeAPI}/occurrences/front/:code`,
                    follow: `${codeAPI}/occurrences/follow/:id`,
                    getTimeline: `${codeAPI}/gestao/communication/:parentId`,
                },
            },
            editfeature: {
                active: false,
                title: 'Editar Ocorrência',
                panel: {
                    show: false,
                    loaded: false,
                    enableEdocLink: false,
                    showUserInitially: false,
                    closeAfterSave: true,
                    closeAfterNotification: true,
                },
                acl: {
                    view: 'COSI_00583',
                    edit: 'COSI_00570',
                    delete: 'COSI_00340',
                    notify: 'COSI_00357',
                    // enableVisibility: 'COSI_00354',
                    updateVisibility: 'COSI_00358',
                    updatePriority: 'COSI_00343',
                    updateChannel: 'COSI_00342',
                    updateState: 'COSI_00344',
                    updateType: 'COSI_00345',
                    updateSubType: 'COSI_00346',
                    updateUnity: 'COSI_00351',
                    updateAssignedTo: 'COSI_00375',
                    updateAddress: 'COSI_00347',
                    updateReferencePoint: 'COSI_00348',
                    updateOriginalDesc: 'COSI_00571',
                    updateDescription: 'COSI_00349',
                    updatePhotos: 'COSI_00350',
                    viewEdocLink: 'COSI_00622',
                    updateEdocLink: 'COSI_00356',
                    updateAll: 'COSI_00339',
                    updateFamily: 'COSI_00653',
                    updateKind: 'COSI_00654',
                    updateEntity: 'COSI_00650',
                    updateCategory: 'COSI_00651',
                    updatePersonData: 'COSI_00652',
                },
                url: {
                    show: `${codeAPI}/occurrences/data/:code`,
                    update: `${codeAPI}/occurrences/:id`,
                    delete: `${codeAPI}/occurrences/:id`,
                    getLists: `${codeAPI}/occurrences/lists`,
                    getSubTypes: `${codeAPI}/occurrences/subtypes/:type`,
                    getUnitsBySubtype: `${codeAPI}/occurrences/unities/subtypes/:subtype`,
                    getNotificationTemplates: `${codeAPI}/occurrences/notifications/manual/form/1`,
                    getSendNotification: `${codeAPI}/occurrences/notifications/manual/send/:id`,
                },
            },
            addfeature: {
                active: true,
                title: 'Nova Ocorrência',
                infoAddFeature: "Clique no mapa para escolher o local da ocorrência.",
                infoNoPermissionAddFeature: "Não possui permissão para adicionar uma nova ocorrência",
                infoOutsideAddFeature: "Não é possível registar uma ocorrência fora do concelho.",
                infoAtiveFilterFeature: "Necessário ativar os filtros para visualizar a ocorrência.",
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'COSI_00335',
                    allowChannel: 'COSI_00353',
                    allowSubType: 'COSI_00376',
                    allowVisibility: 'COSI_00354',
                    allowPhotos: 'COSI_00337',
                    allowReportFrom: 'COSI_00336',
                    allowReportFromUpdateUser: 'COSI_00615',
                    allowReportFromNewUser: 'COSI_00338',
                },
                url: {
                    create: `${codeAPI}/occurrences`,
                    getKinds: `${codeAPI}/occurrences/kinds`,
                    getTypes: `${codeAPI}/occurrences/types`,
                    getLists: `${codeAPI}/occurrences/store/lists`,
                    featureable: `${codeAPI}/occurrences/store/featureable/:x/:y/:crs/:resolution`,
                    searchUser: `${codeAPI}/occurrences/store/search/user?q=:query`,
                    createUser: `${codeAPI}/occurrences/store/user`,
                    updateUser: `${codeAPI}/occurrences/store/user/:id`,
                    reverseAddress: `../gateway/address/reverse/:lat/:lon/:srid`
                },
            },
            notifyfeature: {
                active: true,
                title: 'Notificar',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'COSI_00357',
                },
                url: {
                    getNotificationTemplates: `${codeAPI}/occurrences/notifications/manual/form/1`,
                    getSendNotification: `${codeAPI}/occurrences/notifications/manual/send/:id`,
                },
            },
            features: {
                active: true,
                tooltip: {
                    active: true,
                    template: '<p class="title">:code</p>',
                },
                acl: {
                },
            },
        },
        states: {
        },
        filters: {
        },
        map: {
            loading: false,
            reload: false,
            action: null,
            user_feature: null,
            filters: {
                types: [],
                status: []
            },
            config: {
                layers: {
                    features: {
                        scale: .5,
                        scaleSelected: 1,
                    },
                },
                interactions: {
                    spiderfier: true,
                },
            }
        }
    },


};

export default state;